import css from 'styled-jsx/css'


export default css`
  .container {
    display: flex;
    width: 9.5rem;
    height: 9.5rem;
    border-radius: 4.75rem;
    align-items: center;
    justify-content: center;
  }

  .container > :global(.icon) {
    width: 100%;
    height: 100%;
  }

  .container :global(img) {
    width: 100%;
    height: 100%;
  }
`
